export default [
  {
    path: '',
    name: 'member_card_template_list',
    component: () => import('./List'),
  },
  {
    path: 'new',
    name: 'member_card_template_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'member_card_template_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'member_card_template_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
